import { Component, OnInit } from '@angular/core';
import { IEpGridModel, IEpGridSelectionOptions, EpGridEditMode, IEpGridColumn, IEpGridEditState } from '@epicor/kinetic';
import { EpbtFaLabelsService } from '../../services/epbt-fa-labels.service';
import { LabelTemplateQty, LabelTemplateQtyKind, LabelsRequestPrintingMode } from 'ep-bt-field-agent-proxy';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-label-templates-grid',
  templateUrl: './epbt-fa-label-templates-grid.component.html',
  styleUrls: ['./epbt-fa-label-templates-grid.component.scss']
})
export class EpbtFaLabelTemplatesGridComponent implements OnInit {

  labelTemplateGridModel: IEpGridModel;

  constructor(private labelService: EpbtFaLabelsService, private faService: EpbtFieldAgentService, private productService: EpbtFaProductService) { }

  ngOnInit() {
    this.labelTemplateGridModel = this.getTemplateGridModel();

    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bindLabelTemplates(bisTrackSettings.branchPrinters);
    });

  }

  getTemplateGridModel(): IEpGridModel {
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      editable: true,
      editOptions: {
        defaultEditable: true,
        editMode: EpGridEditMode.cell,
        updateOnChange: true,
        // validation on change of value
        onChangeValidate: (column: IEpGridColumn, newValue: any, originalValue: any, state: IEpGridEditState) => {
          if (column.field === 'requestedQuantity' && (newValue < 0)) {
            return false;
          }
          if (column.field === 'requestedQuantity' && (newValue % 1) > 0) {
            // let num = newValue % 1;
            return false;
          }
          return true;
        }
      },
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: true,
      height: this.getHeight(),
      columns: [
        { field: 'name', title: 'NAME', width: 100, hidden: false, editable: false },
        { field: 'kind', title: 'TYPE', width: 40, hidden: false, class: 'color-blue', editable: false },
        { field: 'defaultQuantity', title: 'DEFAULT QTY', width: 40, hidden: false, editable: false },
        { field: 'requestedQuantity', title: 'REQUESTED QTY', width: 40, hidden: false, class: 'color-blue', editable: true, editor: 'numeric' },
        { field: 'branchPrinterName', title: 'PRINTER', width: 160, hidden: false, class: 'color-blue', editable: false },
      ]
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }

  bindLabelTemplates(branchPrinters) {
    this.labelService.getAllLabelTemplates((allLabelTemplates: LabelTemplateQty[]) => {
      allLabelTemplates.forEach(template => {
        const reqTemplates = this.labelService.labelsRequest.templates;
        if (reqTemplates && reqTemplates.length > 0) {
          const reqTemplate = reqTemplates.find(item => item.id == template.id);
          if (reqTemplate) {
            template.requestedQuantity = reqTemplate.requestedQuantity;
          }
        }
        const printer = branchPrinters.find(p => p.id == template.branchPrinter);
        if (printer) {
          template.branchPrinterName = printer.networkName;
        }
      });
      this.labelService.labelsRequest.templates = allLabelTemplates.filter(t => t.branchPrinter > 0);
      if (this.labelService.labelsRequest.printingMode == LabelsRequestPrintingMode.OnDemand &&
        this.labelService.labelsRequest.products &&
        this.labelService.labelsRequest.products.length == 1 &&
        this.productService.selectedProductItem &&
        this.labelService.labelsRequest.products[0].productId == this.productService.selectedProductItem.productId) {
        this.labelService.labelsRequest.templates.forEach(element => {
          if (element.kind == LabelTemplateQtyKind.Item) {
            element.defaultQuantity = this.productService.selectedProductItem.stockAvailable;
          } else if (element.kind == LabelTemplateQtyKind.Bin || element.kind == LabelTemplateQtyKind.BinLocation) {
            element.defaultQuantity = 1;
          }
        });
      }
      this.labelTemplateGridModel.data = this.labelService.labelsRequest.templates;
    });
  }
  updateGrid() {
    const calHeight = this.getHeight();
    this.labelTemplateGridModel.height = calHeight;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 464;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }

    // if (this.dockType != 'vertical') {
    //   //horizontal
    //   return height - 10;
    // } else {
    //   return height / 2 - 80
    // }
    return height;
  }

}
